export const card = {
   light: {
      None: {
         backgroundColor: 'bg-white',
         borderColor: 'border-gray-300'
      },
      ExtraSmall: {
         backgroundColor: 'bg-white',
         borderColor: 'border-gray-300',
         boxShadow: 'shadow-custom-xs'
      },
      Small: {
         backgroundColor: 'bg-white',
         borderColor: 'border-gray-300',
         boxShadow: 'shadow-custom-sm'
      },
      Medium: {
         backgroundColor: 'bg-white',
         borderColor: 'border-gray-300',
         boxShadow: 'shadow-custom-md'
      },
      Large: {
         backgroundColor: 'bg-white',
         borderColor: 'border-gray-300',
         boxShadow: 'shadow-custom-lg'
      },
      ExtraLarge: {
         backgroundColor: 'bg-white',
         borderColor: 'border-gray-300',
         boxShadow: 'shadow-custom-xl'
      },
      DoubleExtraLarge: {
         backgroundColor: 'bg-white',
         borderColor: 'border-gray-300',
         boxShadow: 'shadow-custom-2xl'
      },
      TripleExtraLarge: {
         backgroundColor: 'bg-white',
         borderColor: 'border-gray-300',
         boxShadow: 'shadow-custom-3xl'
      }
   },
   dark: {}
}
